import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.info.lighter,
    color: theme.palette.info.darker,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
